import validator from '@rjsf/validator-ajv8';
import { Typography } from '@mui/material';
import { generateBatterySchema } from '../../shared/device-details-utils';
import { BRAND_MODEL_UI_SCHEMA } from '../shared';
import BatteryPanelsStep from '../components/battery-step.component';
import { cloneDeep, get } from 'lodash';

export default {
  title: 'Battery',
  description: 'Select and configure the battery system, for energy storage purposes.',
  helperText: {
    header: (
      <>
        <Typography variant="h6">Select the correct battery.</Typography>

        <Typography
          variant="body"
          fontWeight={500}
        >
          ℹ️ Attention: Only FlexIO compatible batteries can be selected.
        </Typography>
      </>
    ),
  },
  component: BatteryPanelsStep,
  schemaFunction: ({ settings, schemas }, batteryChanges) => {
    const { batteryBrandModelSchema, batteryDetailsSchema } = generateBatterySchema(settings, schemas, batteryChanges?.batteryBrandModel);

    return {
      batteryBrandModel: {
        $id: 'batteryBrandModel',
        properties: {
          batteryBrandModel: batteryBrandModelSchema,
        },
      },
      battery: {
        properties: {
          battery: batteryDetailsSchema
            ? {
                ...batteryDetailsSchema[1],
              }
            : null,
        },
      },
    };
  },

  updateUiSchema: (schema, uiSchema) => {
    const ui = cloneDeep(uiSchema);

    Object.entries(schema.battery.properties.battery.properties).forEach(([name, fieldProperties]) => {
      if (fieldProperties.const !== undefined) {
        if (!(name in ui.battery.battery)) {
          ui.battery.battery[name] = {};
        }

        ui.battery.battery[name]['ui:disabled'] = true;
      }
    });

    return ui;
  },

  validateFunction: (schema, formData) => {
    if (!formData) {
      return true;
    }

    let isValid = true;
    if (formData.batteryBrandModel) {
      isValid = validator.isValid(schema.batteryBrandModel, { batteryBrandModel: formData.batteryBrandModel }, schema.batteryBrandModel);
    }

    if (formData.battery) {
      isValid = validator.isValid(schema.battery, { battery: formData.battery }, schema.battery);
    }
    return isValid;
  },

  validateFormData: (schema, formData) => {
    if (!formData) {
      return true;
    }

    const validationData = {};

    if (formData.batteryBrandModel) {
      validationData.batteryBrandModel = validator.validateFormData(schema.batteryBrandModel, {
        batteryBrandModel: formData.batteryBrandModel,
      });
    }

    if (formData.battery) {
      validationData.battery = validator.validateFormData(schema.battery, {
        battery: formData.battery,
      });
    }

    return validationData;
  },

  diffFunction: (diffObj) => {
    return {
      battery: get(diffObj, 'settings.converters[0].battery', false),
      batteryBrandModel: get(diffObj, 'settings.converters[0].battery.batteryType', false),
    };
  },

  uiSchema: {
    batteryBrandModel: {
      batteryBrandModel: BRAND_MODEL_UI_SCHEMA,
    },
    battery: {
      'ui:options': {
        title: '',
        description: '',
      },
      battery: {
        'ui:options': {
          title: '',
          description: '',
        },
        ...Object.fromEntries(
          ['batteryType', 'cellMinVoltage', 'cellRatedVoltage', 'cellMaxVoltage', 'cellMaxCurrent', 'balancingCurrent'].map((key) => [
            key,
            { 'ui:widget': 'hidden' },
          ]),
        ),
      },
    },
  },
};
